import { ContactDetailsTab } from './contactDetailsTab';

require('./contactDetailsTab.scss');

export const myContactDetailsTabComponent = {
  template: require('./contactDetailsTab.html'),
  controllerAs: 'ctrl',
  controller: ContactDetailsTab,
};
